import React from 'react'
import { useNavigate } from 'react-router-dom'
import { TripResponse } from '@/shared/api/types'
import { Calendar, Users } from '@/ui/icons'
import { getTripCoverUrl } from '@/shared/constants'

interface TripsListPanelProps {
  trips: TripResponse[]
  onTripSelect: (trip: TripResponse) => void
  isLoading?: boolean
}

export function TripsListPanel({
  trips,
  onTripSelect,
  isLoading = false
}: TripsListPanelProps) {
  const navigate = useNavigate()

  const handleTripClick = (trip: TripResponse) => {
    navigate(`/explore/trip/${trip.id}`)
  }
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-gray-500">Loading trips...</div>
      </div>
    )
  }

  if (trips.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center h-full text-center p-8">
        <p className="text-gray-500 mb-2">No trips found</p>
        <p className="text-sm text-gray-400">Create a trip to get started</p>
      </div>
    )
  }

  return (
    <div className="h-full overflow-y-auto">
      <div className="p-4">
        <div className="space-y-3">
          {trips.map((trip) => (
            <button
              key={trip.id}
              onClick={() => handleTripClick(trip)}
              className="w-full text-left p-4 rounded-lg border border-gray-200 hover:border-primary hover:shadow-md transition-all bg-white"
            >
              <div className="flex items-start gap-4">
                <img
                  src={getTripCoverUrl(trip.cover_photo_url)}
                  alt={trip.name}
                  className="w-20 h-20 object-cover rounded-lg"
                />
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-gray-900 truncate mb-1">
                    {trip.name}
                  </h3>
                  {trip.description && (
                    <p className="text-sm text-gray-600 line-clamp-2 mb-2">
                      {trip.description}
                    </p>
                  )}
                  <div className="flex items-center gap-4 text-xs text-gray-500">
                    {trip.start_date && (
                      <div className="flex items-center gap-1">
                        <Calendar className="w-3 h-3" />
                        <span>
                          {new Date(trip.start_date).toLocaleDateString()}
                        </span>
                      </div>
                    )}
                    {trip.member_count !== undefined && (
                      <div className="flex items-center gap-1">
                        <Users className="w-3 h-3" />
                        <span>{trip.member_count} members</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}

